import { FormInstance } from "antd";
import { IStructuresAllData } from "store/location/location-model";
import { IUserData } from "store/user-session/user-session-model";
import { isNull, searchLocationByIdSelected } from "utils/functions";
import { getTimeZoneName } from "utils/intl/getLocale";

export interface IExportMovementsReport {
  form: FormInstance<any>;
  locationStructure: IStructuresAllData;
  location: string[] | any;
  reportMovementFetchAsync: (...args) => void;
  locationByStructureIdList: IStructuresAllData[];
  message: string | any;
  messageDescription: string;
  userData: IUserData;
}

export interface IMovementsReportRequest {
  locations?: string[];
  _minEventTime: string;
  _maxEventTime: string;
  locationTimeZone: string;
  structureId: number | any;
  trailerPlate?: string;
  dtDocument?: string;
  plate?: string;
}

export interface IQueryMovementsReport {
  form: FormInstance<any>;
  locationStructure: IStructuresAllData;
  location: string[] | any;
  reportMovementsFetchRegisterAsync: (...args) => void;
  locationByStructureIdList: IStructuresAllData[];
  message: string | any;
  messageDescription: string;
  itemsByPage: number;
  pageIndex: number;
  userData: IUserData;
}

export interface IQueryMovementsReportRequest {
  locations?: string[];
  initialEventTime: string;
  finalEventTime: string;
  structureId: number | any;
  itemsByPage: number;
  pageIndex: number;
  trailerPlate?: string;
  dtDocument?: string;
  plate?: string;
}

const dateFormat = "YYYY-MM-DD";

export const onConfirmExportMovementReport = async ({
  form,
  locationStructure,
  location,
  reportMovementFetchAsync,
  message,
  messageDescription,
  locationByStructureIdList,
  userData,
}: IExportMovementsReport) => {
  try {
    await form.validateFields();
    const plate = form.getFieldValue("plate");
    const trailerPlate = form.getFieldValue("trailerPlate");
    const dtDocument = form.getFieldValue("dtDocument");
    const rangePicker = form.getFieldValue("rangePicker");
    let bodyRequest: IMovementsReportRequest = {
      structureId: locationStructure,
      dtDocument: isNull(dtDocument),
      trailerPlate: isNull(trailerPlate),
      plate: isNull(plate),
      _minEventTime: rangePicker[0].format(dateFormat),
      _maxEventTime: rangePicker[1].format(dateFormat),
      locationTimeZone: getTimeZoneName(),
    };
    if (isNull(location) !== null) {
      const exportLocationId = searchLocationByIdSelected(location, locationByStructureIdList, userData);
      bodyRequest = { ...bodyRequest, locations: exportLocationId };
    }
    reportMovementFetchAsync(bodyRequest);
  } catch (e) {
    message.error(messageDescription);
  }
};

export const onConfirmQueryMovementReport = async ({
  form,
  locationStructure,
  location,
  reportMovementsFetchRegisterAsync,
  message,
  messageDescription,
  itemsByPage,
  pageIndex,
  locationByStructureIdList,
  userData,
}: IQueryMovementsReport) => {
  try {
    await form.validateFields();
    const plate = form.getFieldValue("plate");
    const trailerPlate = form.getFieldValue("trailerPlate");
    const rangePicker = form.getFieldValue("rangePicker");
    const dtDocument = form.getFieldValue("dtDocument");

    let bodyRequest: IQueryMovementsReportRequest = {
      initialEventTime: rangePicker[0].format(dateFormat),
      finalEventTime: rangePicker[1].format(dateFormat),
      structureId: locationStructure,
      dtDocument: isNull(dtDocument),
      trailerPlate: isNull(trailerPlate),
      plate: isNull(plate),
      itemsByPage,
      pageIndex,
    };
    if (isNull(location) !== null) {
      const queryLocationId = searchLocationByIdSelected(location, locationByStructureIdList, userData);
      bodyRequest = { ...bodyRequest, locations: queryLocationId };
    }
    reportMovementsFetchRegisterAsync(bodyRequest);
  } catch (e) {
    message.error(messageDescription);
  }
};
